import React from 'react';

interface Props {
  children: any;
  center?: boolean;
  right?: boolean;
  full?: boolean;
  middle?: boolean;
  bottom?: boolean;
  wrap?: boolean;
  style?: Record<string, any>;
  className?: string;
}

export const Flex = (props: Props) => {
  const {
    children,
    center,
    right,
    full,
    middle,
    bottom,
    wrap,
    style,
    className,
  } = props;

  const styleFlex: React.CSSProperties = {
    display: 'flex',

    // 水平方向の配置
    justifyContent: center
      ? 'center'
      : right
      ? 'flex-end'
      : full
      ? 'space-between'
      : undefined,
    alignContent: full ? 'space-between' : undefined,

    // 垂直方向の配置
    alignItems: middle ? 'center' : bottom ? 'flex-end' : undefined,

    // 要素の折り返し
    flexWrap: wrap ? 'wrap' : undefined,
  };

  return (
    <div style={{ ...styleFlex, ...style }} className={className}>
      {children}
    </div>
  );
};
